/**
* DevExpress Analytics (core\internal\_utils.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolbox_1 = require("../tools/toolbox");
function getToolboxItems(controlsMap, defaultGroup) {
    if (defaultGroup === void 0) { defaultGroup = ''; }
    var toolboxItems = [];
    Object.keys(controlsMap).forEach(function (controlType) {
        if (!controlsMap[controlType].nonToolboxItem) {
            var item = {
                '@ControlType': controlType,
                displayName: controlsMap[controlType].displayName,
                index: controlsMap[controlType].toolboxIndex || 0,
                canDrop: controlsMap[controlType].canDrop,
                group: controlsMap[controlType].group || defaultGroup
            };
            if (controlsMap[controlType].size) {
                item['size'] = controlsMap[controlType].size;
            }
            if (controlsMap[controlType].defaultVal) {
                Object.keys(controlsMap[controlType].defaultVal).forEach(function (name) {
                    item[name] = controlsMap[controlType].defaultVal[name];
                });
            }
            toolboxItems.push(new toolbox_1.ToolboxItem(item));
        }
    });
    return toolboxItems.sort(function (item1, item2) { return item1.index - item2.index; });
}
exports.getToolboxItems = getToolboxItems;
function blur(element) {
    try {
        element['blur'] && element['blur']();
    }
    catch (e) {
        document.body.blur();
    }
}
exports.blur = blur;
